<div class="column-group">
    <ng-container *ngIf="selectable && id != 'Teams'">
        <hpo-select [id]="'column-chooser-dropdown-' + id | lowercase"
            [(selected)]="selectedValue"
            title="{{ title | blah }}"
            [data]="options"
            [searchBy]="'searchValues'"
            (selectedChange)="addColumn($event)"
            [showTooltip]="true">
            <ng-template let-item>
                {{ item.searchValues }}
            </ng-template>
        </hpo-select>
    </ng-container>

    <ng-container *ngFor="let column of displayedColumns">
        <div class="column-container">

            <ng-container *ngIf="column.isNew">
                <button mat-icon-button
                    [id]="'column-remove-btn-' + column.key"
                    (click)="removeColumn(column)">
                    <mat-icon color="enabled-icon">
                        clear
                    </mat-icon>
                </button>

                <div *ngIf="column.isNew">
                    <span [id]="column.key">
                        {{ column.title | titleName: column.group}}
                    </span>
                </div>

            </ng-container>

            <ng-container *ngIf="!column.isNew">
                <mat-checkbox [id]="'column-checkbox-' + column.key"
                    [checked]="!column.hidden"
                    (change)="updateColumn($event, column)">
                    <span class="check-btn">{{ column.title | titleName: column.group}}</span>
                </mat-checkbox>
            </ng-container>

        </div>
    </ng-container>
</div>